module.exports = __webpack_public_path__ + "static/media/subscriptionBg.f6b08f65.png";